<div class="row no-gutter header-wrapper">
  <div class="col-sm-7 header-container">
    @if (classFlag) {
      <button mat-icon-button (click)="opened()" class="menuButton">
        <!-- <mat-icon class="menu" > -->
        <img src="../../../assets/images/hamburger-svgrepo-com.svg" />
      <!-- </mat-icon> -->
    </button>
  }
  <h3 class="header-name">Biometric Authentication System</h3>
</div>
<div class="col-sm-5 keep-right">
  <div class="header-item">

    <!-- For Multiple Downloads -->
    <!-- <div>
    <button [matMenuTriggerFor]="download" *ngIf="user.userDetails.role !== 'fielduser'" class="icon notification"
      (click)="disappear()">
      <img class="notification"
        [src]="downloads.length ? 'assets/images/download-notification-loader.svg' : 'assets/images/download-notification.svg'"
        alt="" />
        <span class="nCount">{{ downloads.length }}</span>
      </button>
      <mat-menu #download="matMenu" class="download-notification">
        <h5>Downloads</h5>
        <div class="downloads-container">
          <div *ngFor="let download of downloads" class="download-item">
            <h6 class="download-id">{{download.fileName}}</h6>
            <mat-progress-bar [mode]="download.progress ? 'determinate': 'indeterminate'" [value]="download.progress"></mat-progress-bar>
            <h6 class="download-progress">{{download.progress}}{{download.progress ? '%': ''}} {{download.status}} </h6>
          </div>
          <div *ngIf="!downloads.length" class="no-downloads">
            <h6>No Downloads</h6>
          </div>
        </div>
      </mat-menu>
    </div> -->

    @if (user.userDetails.role !== 'fielduser') {
      <a routerLink="/dashboard/approvals" class="icon notification"
        (click)="disappear()">
        <img src="assets/images/communication.svg" alt="" />
        @if (
          (role === 'superadmin' || role === 'Vendoradmin') &&
          sharedService.show &&
          count > 0
          ) {
          <span class="nCount">{{ count }}</span>
        }
      </a>
    }
    <div class="trigger-menu header-text">
      <div class="name-header">
        <p class="user-name text-capitalize">{{ userName }}</p>
        <p class="company">
          <span
            >
          {{ vendorName ? vendorName : user.userDetails.vendor.orgName}}</span>
          <!-- <span *ngIf="user.userDetails.role === 'superadmin'">{{vendorName}}</span> -->
        </p>
      </div>
      <div class="header-icon">
        <p [matMenuTriggerFor]="menu" class="prof">
          {{ userName.charAt(0) }}
        </p>
      </div>
    </div>
  </div>
  <mat-menu #menu="matMenu" xPosition="before" class="mt-2 dropdown">
    <!-- <div class="keep-right"> -->
    <!-- <div class="header-item "> -->
    <div class="background">
      <div class="icon">
        <p class="username">{{ userName.charAt(0) }}</p>
      </div>
        <div class="headerName" [ngClass]="
            user.userDetails.role !== 'superadmin' ? 'fielduserHeader' : ''
          ">
        <p class="user-name text-capitalize">{{ userName }}</p>
          <p class="company" [ngClass]="
              user.userDetails.role !== 'superadmin' ? 'fielduserClass' : ''
            ">
          @if (user.userDetails.role !== 'superadmin') {
            <span>{{
              vendorName ? vendorName : user.userDetails.vendor.orgName
            }}</span>
          }
          <!-- <span *ngIf="user.userDetails.role !== 'superadmin'">{{user.userDetails.vendor.orgName ? user.userDetails.vendor.orgName:'-'}}</span> -->
          @if (user.userDetails.role === 'superadmin') {
            <span>+91{{ user.userDetails.mobile }}</span>
          }
        </p>
      </div>
    </div>
  <!-- </div> -->
<!-- </div> -->
<div class="items">
  <button mat-menu-item (click)="onMenuClick('My Profile')">
    <!-- <mat-icon> person </mat-icon> -->
    <span>My Profile</span>
  </button>
  <button mat-menu-item (click)="onMenuClick('My Sites')">
    <!-- <mat-icon> vpn_key </mat-icon> -->
    <span>My Sites</span>
  </button>
  <button mat-menu-item (click)="onMenuClick('Change Password')">
    <!-- <mat-icon> vpn_key </mat-icon> -->
    <span>Change Password</span>
  </button>
</div>

<button mat-menu-item (click)="onMenuClick('Sign Out')" class="signout">
  <!-- <mat-icon> power_settings_new </mat-icon> -->
  <span>Sign Out</span>
</button>
</mat-menu>
<!-- <mat-menu #menu="matMenu" >
<div *ngFor="let menu of dropDownMenuList">
  <a class="dropdown-item" (click)="onMenuClick(menu.menu_name)">{{menu.menu_name}}</a>
</div>
</mat-menu> -->
</div>
</div>